import * as React from 'react';
import { styled,  ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import MenuIcon from '@mui/icons-material/Menu';
import { grey } from '@mui/material/colors';
import { Logout } from '@mui/icons-material';
import { AppBar, Drawer, Tooltip } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';

import logoDefault from "../../components/imgs/logo.png";
import theme from '../../theme';

import { useAuth } from '../AuthProvider';

import { useSearch } from '../SearchProvider';
import Navbar from './Navbar';

const drawerWidth = 240;


const DrawerCustom = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);


export default function MainFrame({menuComponent, admin=false, logo=logoDefault}) {
  const [open, setOpen] = React.useState(false);
  const auth = useAuth()
  const location = useLocation()
  const isMapPage = location.pathname?.split("/").some(path=> path=="map")
  const isTopologyPage = location.pathname?.includes("/topology")
  const [desktopDrawer, setDesktopDrawer] = React.useState(true)
  const { component } = useSearch()
  const toggleDrawer = () => {
    setOpen(!open);
  };

  // Auto-collapse sidebar global quando entra na página de topologia.
  // Operador pode re-expandir manualmente pelo MenuIcon — não force ficar collapsed.
  React.useEffect(() => {
    if (isTopologyPage) {
      setDesktopDrawer(false);
    }
  }, [isTopologyPage]);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar    elevation={2} position='fixed' open={open}
  
        sx={{
          backgroundColor: grey[100],
          height: 64
        }}
        >
          <Toolbar disableGutters
            sx={{
              backgroundColor: {
                xs: '#C4161C',
                sm: '#C4161C',
                md: '#C4161C',
                            },
              pr: '24px', // keep right padding when drawer closed
              height: '64px',
              color: grey[100],
              
              
            }}
            >
              <Box
              display={'flex'}
              justifyContent={"space-around"}
                  >
              </Box>
             
       <Box
        
          justifyContent={"center"}
          alignItems={"center"}
          width={{xs: "auto", sm: "auto", md: "240px"}}
          sx={{
            backgroundColor: grey[900],
            display: {md: "flex"},
            height: 64
          }}
         
          > 
          
          <Toolbar
            sx={{
              display:{xs: "flex", sm: "flex", md:"none"},
            }}
          >

                <Tooltip>
                <IconButton onClick={toggleDrawer} sx={{
                 
                  color: grey[100],
                  
                }}>
                <MenuIcon/>
                </IconButton>
              </Tooltip>
                  </Toolbar>
              <Box
              justifyContent={"space-between"}

              sx={{
                display:{xs: "none", sm: "none", md:"flex"},
              }}>
                <Box>

          <img src={logo}
              
              style={{
                width: 100,
                
                
                
                
              }}
              />
              </Box>
              

          </Box>
          </Box>
              
          <IconButton
            onClick={e=>setDesktopDrawer(!desktopDrawer)}
          sx={{
                display: {xs: "none", sm: "none", md:"flex"},
                color: "white",
                m:1
               }}>
                <MenuIcon/>
              </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"

              noWrap
              sx={{
                flexGrow: 1,

              }}
            ></Typography>
              {component}
            <Typography
              component="h1"
              variant="h6"
              color="inherit"

              noWrap
              sx={{
                flexGrow: 1,

              }}
            ></Typography>
            <Box
            sx={{display:{xs: "flex", sm: "flex", md: "none"},}}
            >

             <img src={logo}
              
              style={{
                width: 100,
               
                
                
                
              }}
              />
            
             
              </Box>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"

              noWrap
              sx={{
                flexGrow: 1,

              }}
            ></Typography>
           
            <Navbar username={auth.name} admin={admin} handlerLogout={()=>auth.signout(() => console.log("Saindo...."))}/>
           
          </Toolbar>
            
        <DrawerCustom variant={!desktopDrawer? "temporary" : "permanent"} open={desktopDrawer} //Drawer desktop
        sx={{
          width: drawerWidth,
          
          display: {xs: "none", sm: "none", md: "block"},
          height: "calc(100vh - 64px)"}}
    
        >
          <Divider />
          
          {menuComponent}
        </DrawerCustom>
        <Drawer variant="temporary" open={open} //drawer responsive
        onClose={toggleDrawer}
        sx={{
          width: drawerWidth,
          display: {xs: "block", sm: "block", md: "display"},
          height: "calc(100vh - 64px)"}}
    
        >
          <Divider />
          {menuComponent}
        </Drawer>
        </AppBar>
       <Box
        sx={{
          width: 240,
          display: {xs: "none", sm: "none", md: desktopDrawer ? "block": "none"},
        }}
       ></Box>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
            ? theme.palette.grey[100]
                : theme.palette.grey[900],
                flexGrow: 1,
               minHeight: '100vh',
              
                
                width:{ sm: "100%", md: `calc(100% - ${drawerWidth}px)` }
            //overflow: 'hidden'
            
          }}
        >
          <Toolbar/>

         
          <Container maxWidth={false} disableGutters={isMapPage}
          sx={{
            ...(!isMapPage && { mt: 4, mb: 4})
          }}
          >
              <Outlet />
          
          </Container>
         
          </Box>
        
          

      </Box>
    </ThemeProvider>
  );
}


